import SelectedPostingDate from '../state/selected-posting-date';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateSelectedPostingDate = (state, action) =>
    SelectedPostingDate.update(state, {
        $set: action.payload
    });

export default (state = getDefaultState().selectedPostingDate, action) => {

    const actionTypes = {
        [actions.UPDATE_REIMBURSEMENT_SUMMARY_SELECTED_POSTING_DATE]: updateSelectedPostingDate
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/reducers/selected-posting-date.js